import { DollarSign, Clock, Filter } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

export default function PerformanceFilters({ mtd, setMtd, mode, setMode, filter, setFilter, canCost }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button variant={mtd ? "default" : "outline"} size="sm" onClick={() => setMtd(true)}>MTD</Button>
      <Button variant={!mtd ? "default" : "outline"} size="sm" onClick={() => setMtd(false)}>Full Month</Button>
      <div className="h-4 w-px bg-border mx-2" />
      {canCost && (
        <>
          <Button variant={mode === "cost" ? "default" : "outline"} size="sm" onClick={() => setMode("cost")}>
            <DollarSign className="w-3 h-3 mr-1" />Cost
          </Button>
          <Button variant={mode === "hours" ? "default" : "outline"} size="sm" onClick={() => setMode("hours")}>
            <Clock className="w-3 h-3 mr-1" />Hours
          </Button>
        </>
      )}
      <div className="h-4 w-px bg-border mx-2" />
      <Select value={filter} onValueChange={setFilter}>
        <SelectTrigger className="w-[140px] h-8">
          <Filter className="w-3 h-3 mr-1" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Types</SelectItem>
          <SelectItem value="Interior">Interior</SelectItem>
          <SelectItem value="Exterior">Exterior</SelectItem>
          <SelectItem value="Animation">Animation</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
